module.exports = __webpack_public_path__ + "img/en.a95b4dcc.svg";